import React, { Component } from "react"
import { Icon } from 'antd'
import $ from 'jquery'
import { inject, observer } from 'mobx-react';
import NavViews from '../../stores/NavViews';

@observer(["CustomRouter", "CategoriesStore", "ViewStore"])
class CategoryLeaguesCarousel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            category: {},
            categoryLogoUrl: '',
            categoryTitle: '',
        };
        this.changeView = this.changeView.bind(this);
    }
    async componentWillMount() {
        const { propsFromLeague, categoryIdFromLeague, CategoriesStore, ViewStore } = this.props;
        let self = this;



        if (propsFromLeague) {
            CategoriesStore.querySingleCategory(categoryIdFromLeague).then(async () => {
                setTimeout(
                    function () {
                        self.setState({ category: Array.from(CategoriesStore.singleCategory.values()) })
                        setTimeout(
                            function () {
                                self.state.category.forEach(function (category) {
                                    self.setState({ categoryLogoUrl: category.logoUrl, categoryTitle: category.title })
                                    self.changeView()
                                });

                            }.bind(self), 50);
                    }.bind(self), 50);
            });
        }

    }
    changeView() {
        this.props.ViewStore.changeView(this.state.categoryTitle + '  /' + '  ' + this.props.leagueTitle);
    }
    handleClickLeft() {
        var actualScroll = $(".leagues-inside-wrap").scrollLeft();
        // To set new position
        $(".leagues-inside-wrap").scrollLeft(actualScroll - 50)
    }

    handleClickRight() {
        var actualScroll = $(".leagues-inside-wrap").scrollLeft();
        // To set new position
        $(".leagues-inside-wrap").scrollLeft(actualScroll + 50)
    }

    handleClickLeft() {
        var actualScroll = $(".categories-inside-wrap").scrollLeft();
        // To set new position
        $(".categories-inside-wrap").scrollLeft(actualScroll - 50)
    }

    renderLeagues() {
        let leagueList = []
        let leagues = this.props.leagues;

        const { CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;
        const { router: { params } } = CustomRouter;

        for (let league of leagues) {
            if (params.leagueId == league._id) {
                leagueList.push(
                    <div onClick={() => goTo(NavViews.leagues, { leagueId: league._id }, CustomRouter)} className="league league-active" key={league._id}>
                        <img src={league.logoUrl} />
                        <span>{league.title}</span>
                    </div>
                )
            } else {
                leagueList.push(
                    <div onClick={() => goTo(NavViews.leagues, { leagueId: league._id }, CustomRouter)} className="league" key={league._id}>
                        <img src={league.logoUrl} />
                        <span>{league.title}</span>
                    </div>
                )
            }
        }

        return leagueList;
    }

    render() {
        const { propsFromLeague, categoryIdFromLeague, CustomRouter } = this.props;
        const { router: { goTo } } = CustomRouter;

        let backBtn = <button className="custom-btn-primary" style={{ margin: '15px 0px 15px 0px' }} onClick={() => goTo(NavViews.home, CustomRouter)} ><Icon type="left" /> BACK TO ALL EVENTS</button>
        let allCategories = "";

        if (propsFromLeague) {

            backBtn = <button className="custom-btn-primary" style={{ margin: '15px 0px 15px 0px' }} onClick={() => goTo(NavViews.categories, { categoryId: categoryIdFromLeague }, CustomRouter)} ><Icon type="left" /> BACK TO {this.state.categoryTitle}</button>

            allCategories = <div onClick={() => goTo(NavViews.categories, { categoryId: categoryIdFromLeague }, CustomRouter)} className="league">
                <img src={this.state.categoryLogoUrl} />
                <span>All {this.state.categoryTitle}</span>
            </div>
        } else {

        }

        return (
            <div>
                <div className="leagues">
                    <div className="arrow-left" onClick={this.handleClickLeft}>
                        <Icon type="left" />
                    </div>
                    <div className="leagues-inside-wrap">
                        {allCategories}
                        {this.renderLeagues()}
                    </div>
                    <div className="arrow-right" onClick={this.handleClickRight}>
                        <Icon type="right" />
                    </div>
                </div>
                {backBtn}
            </div>
        );
    }
}

export default CategoryLeaguesCarousel;



// WEBPACK FOOTER //
// ./src/components/layoutComponents/CategoryLeaguesCarousel.js